import type { ReactNode } from 'react';

import PageHeaderManager from '@/components/layout/PageHeaderManager';
import { UnifiedErrorBoundary } from '@/components/ui/error-boundary';
import { SidebarProvider } from '@/components/ui/sidebar';

interface AnonShellProps {
  children: ReactNode;
}

export default function AnonShell({ children }: AnonShellProps) {
  // No marketing top bar — Medium-style: signed-out visitors see the same
  // chrome as signed-in users, with the Mora wordmark where the page title
  // normally sits and Sign in/Sign up buttons in the actions slot.
  // Hide the mobile SidebarTrigger on anon routes — there's no sidebar to
  // open and showing the hamburger competes with the Mora wordmark.
  return (
    <SidebarProvider defaultOpen={false} cookieName="anon_sidebar_state">
      <div
        data-anon-shell="true"
        className="flex min-h-screen w-full flex-col bg-background text-foreground [&_[data-sidebar=trigger]]:hidden"
      >
        <div data-sticky-header className="sticky top-0 z-20 bg-background">
          <PageHeaderManager />
        </div>
        <main className="flex-1">
          <UnifiedErrorBoundary level="page">{children}</UnifiedErrorBoundary>
        </main>
      </div>
    </SidebarProvider>
  );
}
